<template>

</template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'RegisterRole',
    mounted () {
      /**
       * Init Select2 for permissions 
       */
      const searchPermissions = $('.search-permissions')
      
      searchPermissions.select2({
        placeholder: 'Seleccione los permisos que desea agregar.',
        tokenSeparators: [','],
        language: {
          noResults: function() {
            return 'Permiso no encontrado...'
          },
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if(element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            } else {
              label.insertAfter(element)
            }
            label.addClass('invalid-feedback')
          },
          rules: {
            title: {
              required: true,
            },
            description: {
              required: true,
            },
            'permissions[]': {
              required: true,
            },
          },
          messages: {
            title: {
              required: 'Este campo es requerido.',
            },
            description: {
              required: 'Este campo es requerido.',
            },
            'permissions[]': {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
